import { useContext, type JSX } from "react";
import classNames from "classnames";
import { Trans } from "react-i18next";
import { AppContext } from "../../state";
import { useI18n } from "../../i18n";
import { Container } from "../Container";
import { Content } from "../Content";
import { Heading } from "../Heading";
import { Hint } from "../Hint";
import { BudgetCalculator } from "./BudgetCalculator";
import { BudgetCalculatorResult } from "./BudgetCalculatorResult";
import styles from "./BudgetCalculatorLayout.module.css";

const BudgetCalculatorLayout = (): JSX.Element => {
  const { t, formatNumber } = useI18n();
  const state = useContext(AppContext);
  const showHeader = state.configuration.showHeader;

  const appClasses = classNames(styles.foundation, styles.typography, styles.customVariables, styles.app);

  return (
    <div className={appClasses}>
      <div className={styles.layoutContainer}>
        {showHeader && (
          <Container reducedGap>
            <Content reducedGap>
              <Heading as="h1">
                <Trans i18nKey={"budgetCalculator.heading"} />
              </Heading>
              <Hint>{t("budgetCalculator.hint")}</Hint>
            </Content>
          </Container>
        )}
        <Container>
          <Content background="gray" withPadding>
            <BudgetCalculator />
          </Content>
        </Container>
        <Container>
          <Content background="gray" withLargePadding className={styles.budgetResultContent}>
            <Heading as="h2" className={styles.budgetResultHeading}>
              {t("budgetCalculator.result.heading")}
            </Heading>
            {state.budgetCalculation.hasCalculated &&
            state.budgetCalculation.result &&
            state.budgetCalculation.result.maxBikePrice >= state.configuration.frameContract.price_min ? (
              <BudgetCalculatorResult result={state.budgetCalculation.result} />
            ) : (
              <Hint variant="highlighted">
                <Trans
                  i18nKey="budgetCalculator.result.belowMinPrice"
                  values={{ minBikePrice: formatNumber(state.configuration.frameContract.price_min) }}
                />
              </Hint>
            )}
            <Hint>{t("budgetCalculator.hintFootnote")}</Hint>
          </Content>
        </Container>
      </div>
    </div>
  );
};

export { BudgetCalculatorLayout };
